<template>
  <v-snackbar
    v-model="show"
    :timeout="duration"
    :color="color"
    location="top right"
    elevation="24"
  >
    <div class="d-flex align-center">
      <v-icon class="mr-2">{{ icon }}</v-icon>
      <span>{{ message }}</span>
    </div>
    <template #actions>
      <v-btn
        variant="text"
        icon="close"
        @click="show = false"
      />
    </template>
  </v-snackbar>
</template>

<script setup lang="ts">
import { computed } from 'vue';
import { useToast } from '@/composables/useToast';

const { show, message, type, duration } = useToast();

const color = computed(() => {
  switch (type.value) {
    case 'success':
      return 'success';
    case 'error':
      return 'error';
    case 'warning':
      return 'warning';
    case 'info':
    default:
      return 'info';
  }
});

const icon = computed(() => {
  switch (type.value) {
    case 'success':
      return 'check_circle';
    case 'error':
      return 'error';
    case 'warning':
      return 'warning';
    case 'info':
    default:
      return 'info';
  }
});
</script>
